import moment from 'moment';

const defaultOptions = { timeDiff: 60 * 1000, timeKey: 'epoch', keys: [] };
/**
 * This methods is used to have continuous values of epoch, even if none data was generated.
 * This was, graph shows discontinuities.
 * @param {*} data
 * @param {*} options
 * @returns
 */
export const fillData = (data = [], options) => {
  const _options = { ...defaultOptions, ...options };
  // Even if options are passed with null values, overwrite them.
  Object.keys(_options).forEach((key) => {
    _options[key] = _options[key] || defaultOptions[key];
  });
  const { timeDiff, timeKey, keys } = _options;

  if (!data || data.length < 1) {
    return data;
  }

  // Init with first data
  const res = [data[0]];
  for (let i = 1; i < data.length; i += 1) {
    const lastItem = data[i - 1];
    const currentItem = data[i];

    if (currentItem[timeKey] - lastItem[timeKey] > timeDiff) {
      const nullKeys = {};
      keys.forEach((key) => {
        nullKeys[key] = null;
      });

      const firstNullItem = {
        ...nullKeys,
        epoch: lastItem[timeKey] + timeDiff,
      };

      res.push(firstNullItem);
    }
    res.push(currentItem);
  }
  return res;
};

export const filterDataByEpoch = (data = {}, startEpoch, endEpoch, options) => {
  const _options = { ...defaultOptions, ...options };
  // Even if options are passed with null values, overwrite them.
  Object.keys(_options).forEach((key) => {
    _options[key] = _options[key] || defaultOptions[key];
  });
  if (!data) {
    return data;
  }
  if (!startEpoch && !endEpoch) {
    // return data;
  }

  const sortedData = data.sort((a, b) => {
    const epochA = a[_options.timeKey];
    const epochB = b[_options.timeKey];
    if (epochA > epochB) {
      return 1;
    }
    return -1;
  });

  let startMoment = null;
  if (startEpoch) {
    startMoment = moment(startEpoch);
  } else {
    const firstEpoch = sortedData[0][_options.timeKey];
    startMoment = moment(firstEpoch);
  }

  let endMoment = null;
  if (endEpoch) {
    endMoment = moment(endEpoch);
  } else {
    const lastEpoch = sortedData[sortedData.length - 1][_options.timeKey];
    endMoment = moment(lastEpoch);
  }

  const filteredData = sortedData.filter((sample) => {
    const epoch = sample[_options.timeKey];
    const sampleMoment = moment(epoch);
    if (sampleMoment.isAfter(startMoment) && sampleMoment.isBefore(endMoment)) {
      return true;
    }
    return false;
  });
  return filteredData;
};
